let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lxiFd")).then(() => parcelRequire('5W6v1'));